<template>
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="订单号"><el-input size="small" v-model="formInline.order_no" placeholder="请输入订单号"></el-input></el-form-item>
        <el-form-item label="物流单号"><el-input size="small" v-model="formInline.express_no" placeholder="请输入物流单号"></el-input></el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          <el-button
            type="primary"
            @click="openFullScreen2">
            一键更新物流状态
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" >
         
          <el-table-column prop="order_no" label="订单号"  align="center"></el-table-column>
          <el-table-column prop="express" label="快递公司"  align="center">
            <template slot-scope="scope">
               <p>{{scope.row.express.express_name}}</p>            
            </template>
          </el-table-column>
          <el-table-column prop="express_no" label="物流单号"  align="center"></el-table-column>
          <el-table-column prop="" label="物流状态"  align="center">
            
            <template slot-scope="scope">
              <div v-if="scope.row.express_text==''">暂无物流状态</div>
              <div v-else>{{scope.row.express_text.list.list[0].status}}</div>    
            </template>
          </el-table-column>
          <el-table-column prop="" label="更新时间"  align="center">
            
            <template slot-scope="scope">
              <div v-if="scope.row.express_text==''">暂无物流状态</div>
              <div v-else>{{scope.row.express_text.list.updateTime}}</div>    
            </template>
          </el-table-column>
          
          <el-table-column fixed="right" label="操作" width="160">
            <template slot-scope="scope">
              <el-button @click="track(scope.row)" type="text" size="small" >查看详情</el-button>          
            </template>
            
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
    <Track v-if="show_track" :dataModel="dataModel" @closeDialog="closeDialogFunc($event, 'track')"></Track>
  </div>
</template>

<script>
  import ExpressApi from '@/api/express.js';
  import Track from './dialog/Track.vue';
  export default {
    components: {
    Track,
  },
    data() {
      return {
        show_track:false,
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          order_no: '',
          express_no: '',
        },
        dataModel:[],
      };
    },
    created() {
   
      /*获取列表*/
      this.getTableList();

    },
    methods: {
      openFullScreen2() {
        let self = this;
        const loading = this.$loading({
          lock: true,
          text: '处理中，请稍后',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        ExpressApi.refreshExpressTrack({})
        .then((res) => {
          console.log('更新成功');
          setTimeout(() => {
            self.curPage = 1;
            self.getTableList();
            loading.close();
          }, 2000);
        })
        .catch((error) => {
          setTimeout(() => {
            loading.close();
          }, 2000);
        });
        
      },
      track(item){
        this.dataModel={
          order_id:item.order_id,
          express_name:item.express.express_name,
          express_code:item.express.express_code,
          express_no:item.express_no,
        };
        this.show_track=true;
      },
      /*跳转订单详情*/
      gotoPage(row) {
        let self = this;
        this.$router.push({
          path: '/order/order/detail',
          query: {
            order_id: row.order_id
          }
        });
      },

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        ExpressApi.orderlist(Params).then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        }).catch(error => {
          self.loading = false;
        });
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        self.curPage = 1;
        let Params = self.formInline;
        self.getTableList();
      },


      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'add') {
          this.open_add = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
        if(f=='track'){
          this.show_track = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
      },

    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/plus/express/index.vue